export function isAuthenticatedS3URL (s3Url: string | null | undefined): boolean {
  if (!s3Url) return false

  /** URLs no bucket privado; o front busca via `/auth/line-aws-s3` (Bearer), não direto no S3. */
  const s3AuthenticatedLinks = [
    'https://agxbucket.s3.sa-east-1.amazonaws.com',
    'https://agxbucket.s3-sa-east-1.amazonaws.com',
    'https://corevisionbucket.s3.sa-east-1.amazonaws.com',
    'https://corevisionbucket.s3-sa-east-1.amazonaws.com'
  ]

  return s3AuthenticatedLinks.some((link) => s3Url.startsWith(link))
}
